import { useParams } from 'react-router';
import { Descriptions, Modal } from 'antd';
import { useQuery } from '@apollo/client/react';

import QueryBoundary from 'components/QueryBoundary/QueryBoundary';
import SectionMessage from 'components/SectionMessage/SectionMessage';
import { formatDate } from 'utilities/datesAndTimes';
import { SIZE, STATUS } from 'utilities/constants';
import { CUSTOMER_TRANSUNION_VERIFIED_INFO } from 'queries/customer';

const TransUnionModal = ({ open, ...modalProps }) => {
  const { customerId } = useParams();

  const transunionQuery = useQuery(CUSTOMER_TRANSUNION_VERIFIED_INFO, {
    skip: !open,
    variables: { customerId },
  });

  const transunionVerifiedInfo =
    transunionQuery.data?.customer?.transunionVerifiedInfo;

  const nullError = transunionQuery.data && transunionVerifiedInfo === null;
  const { name, dob } = transunionVerifiedInfo || {};
  const errorMessage = 'Failed to retrieve TransUnion information';

  return (
    <Modal
      title="TransUnion Customer Information"
      open={open}
      cancelButtonProps={{ hidden: true }}
      {...modalProps}
    >
      <QueryBoundary
        query={transunionQuery}
        mode={QueryBoundary.MODE.MESSAGE}
        loadingMessage="Loading TransUnion information"
        errorMessage="Failed to retrieve TransUnion information"
      >
        {nullError ? (
          <SectionMessage
            size={SIZE.SM}
            status={STATUS.ERROR}
            text={errorMessage}
          />
        ) : (
          <Descriptions
            column={1}
            style={{ paddingTop: 'var(--spacing)' }}
            items={[
              {
                key: '1',
                label: 'Name',
                children: name || '-',
              },
              {
                key: '2',
                label: 'Date of Birth',
                children: formatDate(dob),
              },
            ]}
          />
        )}
      </QueryBoundary>
    </Modal>
  );
};

export default TransUnionModal;
